"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useRef } from "react";
import dynamic from "next/dynamic";
import { useBreakpoint } from "@/hooks/useBreakpoint";
import { useInView, useReducedMotion } from "@/hooks/useFramerMotion";
import SpaceOrbitWobble from "@/components/Footer/SpaceOrbitWobble";
const FooterVisual = dynamic(() => import("@/components/3D/Scenes/FooterVisual"), {
  ssr: false
});
const FooterPlanet = dynamic(() => import("@/components/3D/Scenes/FooterPlanet"), {
  ssr: false
});
const FooterSpecial = () => {
  const $ = _c(10);
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      amount: "some"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isInView = useInView(ref, t0);
  const reduce = useReducedMotion();
  const {
    md
  } = useBreakpoint();
  const [showPlanet, setShowPlanet] = useState(false);
  let t1;
  let t2;
  if ($[1] !== md) {
    t1 = () => {
      if (md) {
        setShowPlanet(true);
      } else {
        setShowPlanet(false);
      }
    };
    t2 = [md];
    $[1] = md;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== isInView || $[5] !== reduce || $[6] !== showPlanet) {
    t3 = showPlanet && isInView && <div className="relative flex justify-center py-16"><div className="relative"><div className="relative z-10 -skew-y-3"><div className="scale-y-125 tracking-widest"><div className="flex justify-center gap-3 pb-1 text-center text-sm uppercase"><span className="drop-shadow-[0_0_2px_rgba(255,255,255,0.5)]">Made with that{" "}<span className="font-medium text-mint drop-shadow-[0_0_2px_rgba(0,210,54,0.5)]">cosmic</span></span><span className="relative scale-x-125">🚀</span></div><div className="relative pb-1 pt-1 text-center text-7xl font-black uppercase before:absolute before:left-0 before:top-0 before:w-full before:border-t-[3px] before:border-mint before:drop-shadow-[0_0_2px_rgba(0,210,54,0.5)] before:[border-top-style:double] before:[mask:linear-gradient(to_right,_rgba(0,_0,_0,_0)_0%,_rgb(0,_0,_0)_25%,_rgb(0,_0,_0)_75%,_rgba(0,_0,_0,_0)_100%)] after:absolute after:bottom-0 after:left-0 after:w-full after:border-b-[5px] after:border-mint after:drop-shadow-[0_0_3px_rgba(0,210,54,0.5)] after:[mask:linear-gradient(to_right,_rgba(0,_0,_0,_0)_0%,_rgb(0,_0,_0)_10%,_rgb(0,_0,_0)_90%,_rgba(0,_0,_0,_0)_100%)]"><span className="drop-shadow-[0_0_7px_rgba(255,255,255,0.5)]">MASSIF</span></div><div className="relative flex items-center justify-center gap-3 py-1 text-center font-bold uppercase"><div className="absolute inset-0 -scale-y-75"><FooterVisual /></div><span className="relative pb-1 text-2xl tracking-wide after:absolute after:left-0 after:top-full after:w-full after:border-b-4 after:border-accent after:drop-shadow-[0_0_3px_var(--clr-accent-400)] after:[mask:linear-gradient(to_right,_rgba(0,_0,_0,_0)_0%,_rgb(0,_0,_0)_25%,_rgb(0,_0,_0)_75%,_rgba(0,_0,_0,_0)_100%)]"><span className="drop-shadow-[0_0_3px_rgba(255,255,255,0.5)]">Salsa especial</span></span></div></div></div>{!reduce && <SpaceOrbitWobble className="absolute -inset-36 -skew-y-3" />}</div><div className="absolute -inset-32"><FooterPlanet /></div></div>;
    $[4] = isInView;
    $[5] = reduce;
    $[6] = showPlanet;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <><div ref={ref} className="max-md:order-first md:~translate-x-[2rem]/[6rem] md:~translate-y-[-2rem]/[-12rem]">{t3}</div></>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default FooterSpecial;